<template>
    <div class="event__show">
        <div class="event__show_header">
            <component-induction-message
                :title="'Sessions'"
                :content="'An event has sparked your interest, now it’s time to book onto a session. \n'+
                '\n'+
                'A session is an occurrence of an event you can book onto. They have specific dates, locations and sometimes trainers.'"
                :link-to="''"
                :theme="'tertiary'"
                :route-name="'ebs-event-show'"
            ></component-induction-message>
            <div class="container">
                <div class="columns is-block-mobile">
                    <div class="column">
                        <div class="event__show_header_details">
                            <div class="columns">
                                <div class="column">
                                    <a
                                        class="event__show_hiddenlink hidden"
                                    ></a>
                                    <view-actions
                                        :action-button-visibility="['event_coordinator']"
                                        :cancel-button-active="true"
                                        :cancel-button-text="$t('ebs.events.show.buttons.buttonPrint')"
                                        :cancel-notify-active="false"
                                        :notify-title="$t('ebs.events.show.title.event')"
                                        :size="'small'"
                                        :status-active="true"
                                        :status-name="eventStatus"
                                        :status-visibility="['event_coordinator', 'infrastructure_admin']"
                                        :title="eventName"
                                        :trash-button-active="(eventAllowEdit && !eventAllowEditStatus)"
                                        :trash-button-visibility="['event_coordinator']"
                                        :submit-button-text="$t('ebs.events.show.buttons.buttonEdit')"
                                        :breadcrumb-active="true"
                                        :breadcrumb-items="[
                                            {
                                                name: this.$t('ebs.events.show.title.events'),
                                                to: { name: 'ebs-event-list' }
                                            }
                                        ]"
                                        @emit-notify-remove-submit="eventRemove"
                                        @emit-cancel="eventPrintFlyer"
                                        @emit-submit="eventEdit"
                                    />
                                </div>
                            </div>
                            <template v-if="eventDescription">
                                <div class="event__show_header_details_description" v-html="eventDescription"></div>
                            </template>
                        </div>
                    </div>
                    <template v-if="eventImages.length">
                        <div class="column is-narrow">
                            <div class="event__show_header_image">
                                <component-slider
                                    :images="eventImages"
                                    :alt="eventName"
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="event__show_main">
            <session-list/>
        </div>
    </div>
</template>

<script>
import SessionList from '@/components/ebs/sessions/list/SessionList'
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentSlider from '@/components/default/shared/ComponentSlider'
import ComponentInductionMessage from '@/components/default/shared/ComponentInductionMessage'

export default {
  components: {
    ComponentInductionMessage,
    ComponentSlider,
    ViewActions,
    SessionList
  },
  name: 'event-show',
  computed: {
    eventId: function () {
      return this.$store.getters['getEventId']
    },
    eventName: function () {
      return this.$store.getters['getEventName']
    },
    eventDescription: function () {
      return this.$store.getters['getEventDescription']
    },
    eventStatus: function () {
      return this.$store.getters['getEventStatus']
    },
    eventImages () {
      return this.$store.getters.getEventImage.map(image => {
        return image.imageId
      })
    },
    //
    eventAllowEdit: function () {
      return this.$store.getters.getEventAllowEdit
    },
    eventAllowEditStatus: function () {
      return this.$store.getters.getEventAllowEditStatus
    }
  },
  methods: {
    eventEdit: function () {
      this.$router.push({ name: 'ebs-event-edit', params: { id: this.eventId } })
    },
    eventRemove: function () {
      const eventId = this.$route.params.id
      this.$store.dispatch('removeEvent', eventId)
    },
    eventPrintFlyer () {
      this.$store.dispatch('printEventFlyer', this.eventId)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/events/eventshow";
</style>
